import * as React from "react";
import { connect } from "react-redux";
import PurchaseReturns from "../../screens/PurchaseReturns";

import {
  fetchPurchaseReturns,
  pageSelected,
  ProductReturnview,
  itempageSelected,
  CreditNotesAdd,
  returnrejected,
  returnaccept,
  pdfreturnFullData,
  returnacceptOne,
  returnrejectedOne,
  updateApprovedQty,
  updatePurchaseOrderTotals,
} from "./action";
class PurchaseReturnsContainer extends React.Component<Props, State> {
  render() {
    return (
      <PurchaseReturns
        fetchPurchaseReturns={this.props.fetchPurchaseReturns}
        ProductreturnsDetails={this.props.ProductreturnsDetails}
        ProductreturnsCount={this.props.ProductreturnsCount}
        pageSelected={this.props.pageSelected}
        ProductReturnview={this.props.ProductReturnview}
        ProductReturnDtls={this.props.ProductReturnDtls}
        ItemCount={this.props.ItemCount}
        itempageSelected={this.props.itempageSelected}
        CreditNotesAdd={this.props.CreditNotesAdd}
        returnrejected={this.props.returnrejected}
        returnaccept={this.props.returnaccept}
        pdfreturnFullData={this.props.pdfreturnFullData}
        returnacceptOne={this.props.returnacceptOne}
        returnrejectedOne={this.props.returnrejectedOne}
        updateApprovedQty={this.props.updateApprovedQty}
        updatePurchaseOrderTotals={this.props.updatePurchaseOrderTotals}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    fetchPurchaseReturns: (value) => {
      dispatch(fetchPurchaseReturns(value));
    },
    pageSelected: (value) => {
      dispatch(pageSelected(value));
    },
    ProductReturnview: (value) => {
      dispatch(ProductReturnview(value));
    },
    itempageSelected: (value) => {
      dispatch(itempageSelected(value));
    },
    CreditNotesAdd: (value) => {
      dispatch(CreditNotesAdd(value));
    },
    returnrejected: (value) => {
      dispatch(returnrejected(value));
    },
    returnaccept: (value) => {
      // console.log("value++++++++++valuevalue++++++++++++", value);
      dispatch(returnaccept(value));
    },
    pdfreturnFullData: (value) => {
      dispatch(pdfreturnFullData(value));
    },
    returnacceptOne: (value) => dispatch(returnacceptOne(value)),
    returnrejectedOne: (value) => dispatch(returnrejectedOne(value)),
    updateApprovedQty: (value) => {
      dispatch(updateApprovedQty(value));
    },
    updatePurchaseOrderTotals: (value) => {
      dispatch(updatePurchaseOrderTotals(value));
    },
  };
}
const mapStateToProps = (state) => {
  return {
    ProductreturnsDetails: state.ProductReturnsReducer.ProductreturnsDetails,
    ProductreturnsCount: state.ProductReturnsReducer.ProductreturnsCount,
    ProductReturnDtls: state.ProductReturnsReducer.ProductReturnDtls,
    ItemCount: state.ProductReturnsReducer.ItemCount,
  };
};

export default connect(mapStateToProps, bindAction)(PurchaseReturnsContainer);
